import { Box, Input, VStack } from "@chakra-ui/react"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import KeyboardFormSubmit from "@pathwright/ui/src/components/form/form-utils/KeyboardFormSubmit"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Modal from "@pathwright/ui/src/components/modal/Modal"
import { Field, Form, Formik } from "formik"
import { ConnectStores } from "lib/core/store"
import "./MemberRemove.css"

const MemberRemove = ({ member, onRemove, onCancel, resource, cohort }) => {
  const { t } = useTranslate()
  const isCollection = resource?.resource_type === 30
  const tPrefix = isCollection
    ? "cohort.member.actions.remove_from_collection"
    : "cohort.member.actions.remove"

  return (
    <Modal onClose={onCancel}>
      <VStack pointerEvents="none !important" h="100%" justifyContent="center">
        <Box pointerEvents="auto" bg="white" borderRadius="20px">
          <Formik
            initialValues={{ confirm: "" }}
            validate={(values) => {
              if (values.confirm !== "remove") return { confirm: "required" }
            }}
            validateOnMount
            onSubmit={onRemove}
          >
            {(form) => (
              <Form>
                <KeyboardFormSubmit />
                <BlankSlate
                  layer="overlay"
                  icons={null}
                  icon="caution-triangle"
                  heading={t(`${tPrefix}.heading`, {
                    user: member.user.first_name,
                    cohort: cohort?.name
                  })}
                  body={t(`${tPrefix}.body`, {
                    user: member.user.first_name
                  })}
                  preActionContent={
                    <Field
                      as={Input}
                      name="confirm"
                      placeholder={t(`${tPrefix}.confirm_input`)}
                      autoComplete="off"
                      mt={4}
                      mb="0 !important"
                      autoFocus
                    />
                  }
                  primaryAction={{
                    children: t(`${tPrefix}.confirm_prompt`, {
                      user: member.user.first_name
                    }),
                    dangerous: true,
                    disabled: !form.isValid || form.isSubmitting,
                    submitting: form.isSubmitting,
                    type: "submit"
                  }}
                  secondaryAction={{
                    children: t(`${tPrefix}.cancel`),
                    onClick: onCancel
                  }}
                  stack
                />
              </Form>
            )}
          </Formik>
        </Box>
      </VStack>
    </Modal>
  )
}

MemberRemove.displayName = "MemberRemove"

const mapStateToProps = (state, ownProps) => {
  const { removeMember, unselectMemberForRemoval } = state.memberStore.action
  const { resource, offering: cohort } = state.resourceStore.state
  const onRemove = () => removeMember(ownProps.member).promise
  const onCancel = unselectMemberForRemoval

  return _.assign(
    {},
    {
      onRemove,
      onCancel,
      resource,
      cohort
    },
    ownProps
  )
}

const stores = [
  { store: "member", watch: ["member_removing"] },
  { store: "resource", watch: ["resource", "offering"] }
]

export default ConnectStores(MemberRemove, stores, {}, mapStateToProps)
